// Others.
import moment from 'moment'

export default {
    data: () => ({
        others: {moment},
    }),
    methods: {
        getPreparedProblemaCondicao(value) {
            const problemaCondicao = {
                id: null,
                ciap: value.ciap.id ? value.ciap : null,
                cid: value.cid.id ? value.cid : null,
                incluirListaPaciente: value.situacaoId ? !!value.situacaoId : false,
                situacaoId: value.situacaoId ? value.situacaoId : null,
                situacaoNome: value.situacaoNome ? value.situacaoNome : null,
                observacao: value.observacao ? value.observacao : null,
            }

            if (value.inicio) {
                const dataInicio = this.others.moment(value.inicio, 'DD/MM/YYYY')
                const dataNascimento = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')

                const inicioAnos = dataInicio.diff(dataNascimento, 'years')
                const inicioMeses = dataInicio.diff(dataNascimento, 'months')

                problemaCondicao.inicioData = dataInicio.toDate()
                problemaCondicao.inicioAno = inicioAnos
                problemaCondicao.inicioMes = inicioMeses % 12
            }

            if (value.fim) {
                const dataFim = this.others.moment(value.fim, 'DD/MM/YYYY')
                const dataNascimento = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')

                const fimAnos = dataFim.diff(dataNascimento, 'years')
                const fimMeses = dataFim.diff(dataNascimento, 'months')

                problemaCondicao.fimData = dataFim.toDate()
                problemaCondicao.fimAno = fimAnos
                problemaCondicao.fimMes = fimMeses % 12
            }

            return problemaCondicao
        },
        getPreparedProblemaCondicaoPaciente(value) {
            const problemaCondicaoPaciente = {
                problemaCondicaoPacienteId: value.id,
                ciap: value.ciap.id ? value.ciap : null,
                cid: value.cid.id ? value.cid : null,
                incluirListaPaciente: !!value.situacaoId,
                situacaoId: value.situacaoId,
                situacaoNome: value.situacaoNome,
                observacao: value.observacao,
            }

            if (value.inicio) {
                const dataInicio = this.others.moment(value.inicio, 'DD/MM/YYYY')
                const dataNascimento = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')

                const inicioAnos = dataInicio.diff(dataNascimento, 'years')
                const inicioMeses = dataInicio.diff(dataNascimento, 'months')

                problemaCondicaoPaciente.inicioData = dataInicio.toDate()
                problemaCondicaoPaciente.inicioAno = inicioAnos
                problemaCondicaoPaciente.inicioMes = inicioMeses % 12
            }

            if (value.fim) {
                const dataFim = this.others.moment(value.fim, 'DD/MM/YYYY')
                const dataNascimento = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')

                const fimAnos = dataFim.diff(dataNascimento, 'years')
                const fimMeses = dataFim.diff(dataNascimento, 'months')

                problemaCondicaoPaciente.fimData = dataFim.toDate()
                problemaCondicaoPaciente.fimAno = fimAnos
                problemaCondicaoPaciente.fimMes = fimMeses % 12
            }

            return problemaCondicaoPaciente
        },
    },
}